import { Home, MessageCircle, Plus, Bookmark, User } from 'lucide-react';
import { t } from '../lib/i18n';

interface BottomNavProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export function BottomNav({ activeTab, onTabChange }: BottomNavProps) {
  const translations = t();
  
  const tabs = [
    { id: 'home', label: translations.nav.home, icon: Home },
    { id: 'chats', label: translations.nav.chats, icon: MessageCircle },
    { id: 'add', label: translations.nav.add, icon: Plus },
    { id: 'saved', label: translations.nav.saved, icon: Bookmark },
    { id: 'profile', label: translations.nav.profile, icon: User },
  ];

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 h-16 glass backdrop-blur-2xl border-t border-white/10 z-50"
      style={{
        boxShadow: '0 -4px 24px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.1)'
      }}
    >
      <div className="flex items-center justify-around h-full max-w-md mx-auto px-2">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          const isAdd = tab.id === 'add';
          
          if (isAdd) {
            return (
              <button
                key={tab.id}
                onClick={() => onTabChange(tab.id)}
                className="flex flex-col items-center justify-center relative"
                data-testid="add-button"
              >
                <div 
                  className="w-14 h-14 rounded-full flex items-center justify-center -mt-6 relative overflow-hidden border-2 border-white/20"
                  style={{
                    background: 'linear-gradient(135deg, #00FF88 0%, #00CC6A 100%)',
                    boxShadow: '0 0 40px rgba(0, 255, 136, 0.5), 0 4px 20px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.3)'
                  }}
                >
                  <Icon className="w-7 h-7 text-splyt-dark" strokeWidth={2.5} />
                </div>
              </button>
            );
          }
          
          const isChats = tab.id === 'chats';
          
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className="flex flex-col items-center justify-center gap-1 py-2 px-4 transition-all relative rounded-2xl"
            >
              {isActive && !isChats && (
                <div 
                  className="absolute inset-0 rounded-2xl border glass backdrop-blur-xl"
                  style={{
                    background: 'rgba(0, 255, 136, 0.08)',
                    borderColor: 'rgba(0, 255, 136, 0.2)',
                    boxShadow: '0 0 20px rgba(0, 255, 136, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.1)'
                  }}
                />
              )}
              {isActive && isChats && (
                <div 
                  className="absolute inset-0 rounded-2xl border glass backdrop-blur-xl"
                  style={{
                    background: 'rgba(0, 255, 136, 0.08)',
                    borderColor: 'rgba(0, 255, 136, 0.2)',
                    boxShadow: 'rgba(0, 255, 136, 0.2) 0px 0px 20px, rgba(255, 255, 255, 0.1) 0px 1px 0px inset'
                  }}
                />
              )}
              <Icon 
                className="w-6 h-6 relative z-10" 
                strokeWidth={2}
                style={{ 
                  color: isActive ? '#00FF88' : 'rgba(255, 255, 255, 0.5)',
                  filter: isActive ? 'drop-shadow(0 0 8px rgba(0, 255, 136, 0.6))' : 'none',
                  transition: 'all 0.3s'
                }}
              />
            </button>
          );
        })}
      </div>
    </div>
  );
}



